import React from 'react';
import './Services.css';

const Services = () => {
  return (
    <section className="services" id="services">
      <div className="services-section">
        <div className="services-container">
          <div className="services-header">
            <div className="services-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7v10c0 5.55 3.84 9.74 9 11 5.16-1.26 9-5.46 9-11V7l-10-5z" fill="#8b5cf6"/>
                <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2 className="services-title">Our Services</h2>
            <div className="services-underline"></div>
            <p className="services-subtitle">Explore the services we offer to help your business grow.</p>
          </div>

          <div className="services-cards">
            {/* Software Development */}
            <div className="service-card">
              <div className="card-background"></div>
              <div className="card-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" className="icon-svg">
                  {/* Code brackets */}
                  <path d="M16 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="code-bracket"/>
                  <path d="M8 6l-6 6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="code-bracket"/>
                  {/* Code lines */}
                  <path d="M10 8h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className="code-line blink-line"/>
                  <path d="M10 12h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className="code-line blink-line delay-1"/>
                  <path d="M10 16h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className="code-line blink-line delay-2"/>
                </svg>
              </div>
              <h3 className="card-title">Software Development</h3>
              <p className="card-description">
                Your ideas are turned into software by our IT team, which creates the 
                foundation for successful business operations.
              </p>
              <div className="card-hover-effect"></div>
            </div>

            {/* Web Development */}
            <div className="service-card">
              <div className="card-background"></div>
              <div className="card-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" className="icon-svg">
                  {/* Browser window */}
                  <rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
                  <path d="M8 21l-2-2 2-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 21l2-2-2-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  {/* Browser dots */}
                  <circle cx="6" cy="7" r="1" fill="currentColor" className="browser-dot"/>
                  <circle cx="9" cy="7" r="1" fill="currentColor" className="browser-dot delay-1"/>
                  <circle cx="12" cy="7" r="1" fill="currentColor" className="browser-dot delay-2"/>
                  {/* Content lines */}
                  <path d="M6 11h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className="typing-line"/>
                  <path d="M6 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className="typing-line delay-1"/>
                </svg>
              </div>
              <h3 className="card-title">Web Development</h3>
              <p className="card-description">
                High-performance websites that instantly captivate users and 
                encourage conversions are what we design and develop.
              </p>
              <div className="card-hover-effect"></div>
            </div>

            {/* Maintenance & Support */}
            <div className="service-card">
              <div className="card-background"></div>
              <div className="card-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" className="icon-svg">
                  {/* Wrench/tool */}
                  <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" stroke="currentColor" strokeWidth="2" className="tool-rotate"/>
                  {/* Gear/settings */}
                  <circle cx="18" cy="6" r="2" stroke="currentColor" strokeWidth="2" className="gear-spin"/>
                  {/* Support dots */}
                  <circle cx="8" cy="18" r="1" fill="currentColor" className="support-dot"/>
                  <circle cx="6" cy="16" r="1" fill="currentColor" className="support-dot delay-1"/>
                  <circle cx="10" cy="16" r="1" fill="currentColor" className="support-dot delay-2"/>
                </svg>
              </div>
              <h3 className="card-title">Maintenance & Support</h3>
              <p className="card-description">
                We'll maintain your software up to date so that it can power your 
                company all day.
              </p>
              <div className="card-hover-effect"></div>
            </div>

            {/* Digital Transformation */}
            <div className="service-card">
              <div className="card-background"></div>
              <div className="card-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" className="icon-svg">
                  {/* Digital transformation arrow */}
                  <path d="M7 7h10v10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7 17L17 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="transform-arrow"/>
                  {/* Digital nodes */}
                  <circle cx="7" cy="7" r="2" stroke="currentColor" strokeWidth="2" className="digital-node"/>
                  <circle cx="17" cy="17" r="2" stroke="currentColor" strokeWidth="2" className="digital-node delay-1"/>
                  <circle cx="12" cy="12" r="1.5" fill="currentColor" className="pulse-center"/>
                  {/* Connection lines */}
                  <path d="M9 9l2 2" stroke="currentColor" strokeWidth="1" strokeLinecap="round" className="connection-line"/>
                  <path d="M13 13l2 2" stroke="currentColor" strokeWidth="1" strokeLinecap="round" className="connection-line delay-1"/>
                </svg>
              </div>
              <h3 className="card-title">Digital Transformation</h3>
              <p className="card-description">
                Hire our best brains to help your business successfully undergo a 
                digital transformation that supports your goals.
              </p>
              <div className="card-hover-effect"></div>
            </div>

            {/* Product Design */}
            <div className="service-card">
              <div className="card-background"></div>
              <div className="card-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" className="icon-svg">
                  {/* Design canvas */}
                  <rect x="3" y="3" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
                  {/* Design elements */}
                  <rect x="7" y="7" width="4" height="2" rx="1" fill="currentColor" className="design-element"/>
                  <rect x="13" y="7" width="2" height="2" rx="1" fill="currentColor" className="design-element delay-1"/>
                  <circle cx="8" cy="12" r="1.5" fill="currentColor" className="design-element delay-2"/>
                  <rect x="11" y="11" width="4" height="1" rx="0.5" fill="currentColor" className="design-element"/>
                  {/* Design tools */}
                  <path d="M3 19l3-3 3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="design-tool"/>
                  <circle cx="18" cy="20" r="2" stroke="currentColor" strokeWidth="2" className="design-cursor"/>
                  {/* Sparkle effects */}
                  <path d="M16 5l1-1M17 5l-1-1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className="sparkle"/>
                  <path d="M13 4l0.5-0.5M13.5 4l-0.5-0.5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" className="sparkle delay-1"/>
                </svg>
              </div>
              <h3 className="card-title">Product Design</h3>
              <p className="card-description">
                With a knowledgeable team and practical design solutions, create a digital 
                product that is genuinely focused on the needs of the user.
              </p>
              <div className="card-hover-effect"></div>
            </div>

            {/* Team Training */}
            <div className="service-card">
              <div className="card-background"></div>
              <div className="card-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" className="icon-svg">
                  {/* People/team */}
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" className="team-member"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" strokeWidth="2"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="2"/>
                  {/* Training/education symbols */}
                  <path d="M12 6l8-3-8-3-8 3 8 3z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="graduation-cap"/>
                  <path d="M12 6v6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  {/* Knowledge/skill indicators */}
                  <circle cx="15" cy="8" r="1" fill="currentColor" className="skill-indicator"/>
                  <circle cx="17" cy="10" r="1" fill="currentColor" className="skill-indicator delay-1"/>
                  <circle cx="19" cy="8" r="1" fill="currentColor" className="skill-indicator delay-2"/>
                  {/* Growth arrow */}
                  <path d="M18 14l2-2-2-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="growth-arrow"/>
                </svg>
              </div>
              <h3 className="card-title">Team Training</h3>
              <p className="card-description">
                Tackle today's digital skills gap by professionally upskilling your workforce!
              </p>
              <div className="card-hover-effect"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;